export default "__VITE_ASSET__CiyG6XM6__"